let rootPrefix = '/';
if (process.env.ROOT_PREFIX) {
  rootPrefix = process.env.ROOT_PREFIX;
}

const generatePrefixedRootContext = (path) => `/${path}`;

const shared = {
  routes: {
    root: generatePrefixedRootContext('cover'),
    questionnaire: {
      root: generatePrefixedRootContext(''),
    },
    accredited: {
      root: generatePrefixedRootContext('accredited'),
    },
    knowledge: {
      root: generatePrefixedRootContext('knowledge'),
    },
    experience: {
      root: generatePrefixedRootContext('experience'),
    },
    thanks: {
      root: generatePrefixedRootContext('thanks'),
    },
    review: {
      root: generatePrefixedRootContext('pending_review'),
    },
    progress: {
      root: generatePrefixedRootContext('progress'),
    },
    failedtest: {
      root: generatePrefixedRootContext('failed'),
    },
    locked: {
      root: generatePrefixedRootContext('locked'),
    },
    passedtest: {
      root: generatePrefixedRootContext('passed'),
    },
    mistake: {
      root: generatePrefixedRootContext('mistake'),
    },
  },
  rootPrefix: rootPrefix,
};

export {shared};
